<template>
  <div id="spore-real" style="overflow:hidden;">
    <div class="sporeReal-data">
      <div class="sporeReal-data-head">
        <div class="sporeReal-head-left">
          <span class="sporeReal-left-title" >孢子实时数据</span>
        </div>
        <div class="sporeReal-head-right" >
          <div class="sporeReal-right-select">
            设备名
            <el-select @change="sporeRealChange($event)" v-model="sporeDevice" filterable>
              <el-option :key="item.deviceAddr" :label="item.deviceName" :value="item.deviceAddr" v-for="item in sporeOption"></el-option>
            </el-select>
          </div>
        </div>
      </div>

      <div class="sporeReal-data-content" style="overflow:auto; ">
        <div class="sporeReal-content-top">
          <div class="sporeReal-top-container">
            <div class="sporeReal-top-img">
              <div class="sporeReal-top-img-container">
                <img src="../img/deviceName.png">
              </div>
<!--              <img src="../img/sporeName.png" style="height: 32px; height: 32px; padding-left: 25%; padding-top: 55%">-->
            </div>
            <div class="sporeReal-top-name">
              <div class="sporeReal-top-name-container">
                <span>设备名称</span><br/><span>{{sporeDeviceName}}</span>
              </div>
            </div>
          </div>

          <div class="sporeReal-top-container" >
            <div class="sporeReal-top-img">
              <div class="sporeReal-top-img-container" >
                <img src="../img/deviceAddr.png">
              </div>
            </div>
            <div class="sporeReal-top-name" >
              <div class="sporeReal-top-name-container" >
                <span>设备地址</span><br/><span>{{sporeDeviceAddr}}</span>
              </div>
            </div>
          </div>

          <div class="sporeReal-top-container" >
            <div class="sporeReal-top-img" >
              <div class="sporeReal-top-img-container">
                <img src="../img/deviceState.png">
              </div>
            </div>
            <div class="sporeReal-top-name">
              <div class="sporeReal-top-name-container">
                <span>设备状态</span><br/><span>{{sporeStatus}}</span>
              </div>
            </div>
          </div>

          <div class="sporeReal-top-container">
            <div class="sporeReal-top-img" >
              <div class="sporeReal-top-img-container" >
                <img src="../img/deviceType.png">
              </div>
            </div>
            <div class="sporeReal-top-name" >
              <div class="sporeReal-top-name-container" >
                  <span>设备类型</span><br/><span>{{sporeType}}</span>
              </div>
            </div>
          </div>

          <div class="sporeReal-top-container" >
            <div class="sporeReal-top-img" >
              <div class="sporeReal-top-img-container" >
                <img src="../img/sporePulse.png">
              </div>
            </div>
            <div class="sporeReal-top-name" >
              <div class="sporeReal-top-name-container" >
                <span>单次脉冲数</span><br/><span>{{sporePulseCurrent}}</span>
              </div>
            </div>
          </div>

          <div class="sporeReal-top-container" >
            <div class="sporeReal-top-img" >
              <div class="sporeReal-top-img-container" >
                <img src="../img/sporeSumPulse.png">
              </div>
            </div>
            <div class="sporeReal-top-name">
              <div class="sporeReal-top-name-container">
                <span>累计脉冲数</span><br/><span>{{sporePulseTotal}}</span>
              </div>
            </div>
          </div>

          <div class="sporeReal-top-container">
            <div class="sporeReal-top-img" >
              <div class="sporeReal-top-img-container" >
                <img src="../img/sporeHeight.png">
              </div>
            </div>
            <div class="sporeReal-top-name">
              <div class="sporeReal-top-name-container">
                <span>海拔高度</span><br/><span>{{sporeAltitude}}米</span>
              </div>
            </div>
          </div>
        </div>

        <div class="sporeReal-content-middle">
          <div class="sporeReal-middle-title" :style="sporeRadio != '' ? '' : 'pointer-events: none; '">
            <div class="sporeReal-title-name">
              <span class="sporeReal-title-name-container">运行模式</span>
            </div>
            <div class="sporeReal-title-value">
              <el-radio-group @change="sporeModel" v-model="sporeRadio" class="sporeReal-title-value-container">
                <el-radio-button label="0">手动</el-radio-button>
                <el-radio-button label="1">自动</el-radio-button>
              </el-radio-group>
            </div>
          </div>
          <div class="sporeReal-middle-body">
            <div class="sporeReal-body-hand" :style="sporeRadio == '0' ? '' : 'pointer-events: none; '">
              <dv-border-box-12>
                <div class="sporeReal-hand-name">
                  <span class="sporeReal-hand-name-container">手动模式</span>
                </div>

                <div class="sporeReal-hand-content">
                  <div class="sporeReal-hand-basic">
                    <div class="sporeReal-hand-left">
                      <div class="spore-hand-left-name" >
                        <span class="spore-hand-left-nameContainer" >光源状态</span>
                      </div>
                      <div class="spore-hand-left-value">
                        <span class="spore-hand-left-valueContainer" @click="setLampHState">{{sporeLightStatus}}</span>
                      </div>
                    </div>

                    <div class="sporeReal-hand-right">
                      <div class="spore-hand-right-name">
                        <span class="spore-hand-right-nameContainer">采样口状态</span>
                      </div>
                      <div class="spore-hand-right-value">
                        <span class="spore-hand-right-valueContainer" @click="setSPortStatus">{{sporeSPortStatus}}</span>
                      </div>
                    </div>
                  </div>

                  <div class="sporeReal-hand-basic" style=";margin-top: 2%;">
                    <div class="sporeReal-hand-left">
                      <div class="spore-hand-left-name">
                        <span class="spore-hand-left-nameContainer">排气口状态</span>
                      </div>
                      <div class="spore-hand-left-value" >
                        <span class="spore-hand-left-valueContainer" @click="setBlowVStatus">{{sporeBlowStatus}}</span>
                      </div>
                    </div>

                    <div class="sporeReal-hand-right" >
                      <div class="spore-hand-right-name">
                        <span class="spore-hand-right-nameContainer">载玻带电机状态</span>
                      </div>
                      <div class="spore-hand-right-value">
                        <span class="spore-hand-right-valueContainer" @click="setZBDMotorStatus">{{sporeZBDMotorStatus}}</span>
                      </div>
                    </div>
                  </div>

                  <div class="sporeReal-hand-basic" style="margin-top: 2%;">
                    <div class="sporeReal-hand-left">
                      <div class="spore-hand-left-name">
                        <span class="spore-hand-left-nameContainer">吸气口状态</span>
                      </div>
                      <div class="spore-hand-left-value">
                        <span class="spore-hand-left-valueContainer" @click="setAPortStatus">{{sporeAPortStatus}}</span>
                      </div>
                    </div>
                    <div class="sporeReal-hand-right" >
                      <div class="spore-hand-right-name">
                        <span class="spore-hand-right-nameContainer">摄像头</span>
                      </div>
                      <div class="spore-hand-right-value">
                        <span class="spore-hand-right-valueContainer" @click="setPhotoGraph">拍摄</span>
                      </div>
                    </div>
                  </div>

                </div>
              </dv-border-box-12>
            </div>

            <div class="sporeReal-body-auto" :style="sporeRadio == '1' ? '' : ' pointer-events: none; '">
              <dv-border-box-12>
                <div class="sporeReal-auto-name">
                  <span class="sporeReal-auto-name-container">自动模式</span>
                </div>

                <div class="sporeReal-auto-content">
                  <div class="sporeReal-auto-basic">
                    <div class="sporeReal-auto-left">
                      <div class="spore-auto-left-name" >
                        <span class="spore-auto-left-nameContainer">开始时间</span>
                      </div>
                      <div class="spore-auto-left-value">
                        <el-input v-model="sporeStartTime" placeholder="08:00:00"class="spore-auto-left-valueContainer" ></el-input>
                      </div>
                    </div>

                    <div class="sporeReal-auto-right">
                      <div class="spore-auto-right-name">
                        <span class="spore-auto-right-nameContainer">采样时长(M,N)</span>
                      </div>
                      <div class="spore-auto-right-value" style="width: 100%; height: 60%; display: table">
                        <el-input v-model="sporeSamplingTime" placeholder="0,30"  class="spore-auto-right-valueContainer"></el-input>
                      </div>
                    </div>
                  </div>

                  <div class="sporeReal-auto-basic" style=" margin-top: 2%;">
                    <div class="sporeReal-auto-left">
                      <div class="spore-auto-left-name">
                        <span class="spore-auto-left-nameContainer" >工作时长(M,N)</span>
                      </div>
                      <div class="spore-auto-left-value" >
                        <el-input v-model="sporeRunHour" placeholder="24,0" class="spore-auto-left-valueContainer"></el-input>
                      </div>
                    </div>

                    <div class="sporeReal-auto-right">
                      <div class="spore-auto-right-name">
                        <span class="spore-auto-right-nameContainer">工作间隔(M,N)</span>
                      </div>
                      <div class="spore-auto-right-value">
                        <el-input v-model="sporeWorkInterval" placeholder="1,59"  class="spore-auto-right-valueContainer"></el-input>
                      </div>
                    </div>
                  </div>

                  <div class="sporeReal-auto-basic"  style="margin-top: 2%; ">
                    <div class="sporeReal-auto-left">
                      <div class="spore-auto-left-name">
                        <span class="spore-auto-left-nameContainer">单次移动脉冲数</span>
                      </div>
                      <div class="spore-auto-left-value">
                        <el-input v-model="sporeSinglePulse" placeholder="0" class="spore-auto-left-valueContainer"></el-input>
                      </div>
                    </div>
                    <div class="sporeReal-auto-right">
                      <div class="spore-auto-right-name">
                        <span class="spore-auto-right-nameContainer">累计脉冲上限</span>
                      </div>
                      <div class="spore-auto-right-value">
                        <el-input v-model="sporePulseUpperLimit" placeholder="0" class="spore-auto-right-valueContainer"></el-input>
                      </div>
                    </div>
                    <div class="sporeReal-auto-btn">
                      <el-button @click="setAutoMode" type="primary" plain style="position: absolute; bottom: 0%;">修改</el-button>
                    </div>
                  </div>
                </div>
              </dv-border-box-12>
            </div>
          </div>
        </div>

        <div class="sporeReal-content-bottom">
          <div class="sporeReal-bottom-container">
            <div class="sporeReal-bottom-img">
              <div class="sporeReal-bottom-img-container">
                <img src="../img/deviceSave.png">
              </div>
              <!--              <img src="../img/sporeName.png" style="height: 32px; height: 32px; padding-left: 25%; padding-top: 55%">-->
            </div>
            <div class="sporeReal-bottom-name">
              <div class="sporeReal-bottom-name-container" >
                <span>数据保存间隔</span><br/><span >{{sporeSaveInterval}}分钟</span>
              </div>
            </div>
          </div>

          <div class="sporeReal-bottom-container">
            <div class="sporeReal-bottom-img" >
              <div class="sporeReal-bottom-img-container">
                <img src="../img/deviceOff.png">
              </div>
              <!--              <img src="../img/sporeName.png" style="height: 32px; height: 32px; padding-left: 25%; padding-top: 55%">-->
            </div>
            <div class="sporeReal-bottom-name" >
              <div class="sporeReal-bottom-name-container" >
                <span>离线判断间隔</span><br/><span>{{sporeOffInterval}}分钟</span>
              </div>
            </div>
          </div>

          <div class="sporeReal-bottom-container">
            <div class="sporeReal-bottom-img" >
              <div class="sporeReal-bottom-img-container">
                <img src="../img/sporeYStatus.png">
              </div>
              <!--              <img src="../img/sporeName.png" style="height: 32px; height: 32px; padding-left: 25%; padding-top: 55%">-->
            </div>
            <div class="sporeReal-bottom-name" >
              <div class="sporeReal-bottom-name-container">
                <span>Y轴电机状态</span><br/><span>{{sporeYMStatus}}</span>
              </div>
            </div>
          </div>

          <div class="sporeReal-bottom-container" style="width: 13%;">
            <div class="sporeReal-bottom-img">
              <div class="sporeReal-bottom-img-container" >
                <img src="../img/sporeYSize.png">
              </div>
              <!--              <img src="../img/sporeName.png" style="height: 32px; height: 32px; padding-left: 25%; padding-top: 55%">-->
            </div>
            <div class="sporeReal-bottom-name">
              <div class="sporeReal-bottom-name-container">
                <span>Y轴电机脉冲范围</span><br/><span>{{sporeYMLimit}}</span>
              </div>
            </div>
          </div>

          <div class="sporeReal-bottom-container">
            <div class="sporeReal-bottom-img">
              <div class="sporeReal-bottom-img-container">
                <img src="../img/sporeYPulse.png">
              </div>
              <!--              <img src="../img/sporeName.png" style="height: 32px; height: 32px; padding-left: 25%; padding-top: 55%">-->
            </div>
            <div class="sporeReal-bottom-name" >
              <div class="sporeReal-bottom-name-container" >
                <span>Y轴电机脉冲数</span><br/><span>{{sporeYMPulse}}</span>
              </div>
            </div>
          </div>

          <div class="sporeReal-bottom-container">
            <div class="sporeReal-bottom-img">
              <div class="sporeReal-bottom-img-container" >
                <img src="../img/sporeYDir.png">
              </div>
              <!--              <img src="../img/sporeName.png" style="height: 32px; height: 32px; padding-left: 25%; padding-top: 55%">-->
            </div>
            <div class="sporeReal-bottom-name" >
              <div class="sporeReal-bottom-name-container" >
                <span>Y轴电机方向</span><br/><span>{{sporeYMDirection}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {deviceModel, deviceOper, modSporeAutoMode, sporeAutoMode, sporeDeviceInfo} from "../../until/api/SporePest";

  export default {
    name: 'SporeRealData',
    components: {},
    data() {
      return {
        sporeOption:[],
        sporeDevice: '',
        sporeDeviceName: '-',
        sporeDeviceAddr: '-',
        sporeStatus: '-',
        sporeType: '-',
        sporePulseCurrent: '-',
        sporePulseTotal: '-',
        sporeAltitude: '-',
        sporeYMStatus: '-',
        sporeYMLimit: '-',
        sporeYMPulse: '-',
        sporeYMDirection: '-',
        sporeSaveInterval: '-',
        sporeOffInterval: '-',
        sporeRadio: '',
        sporeLightStatus: '-',
        sporeSPortStatus: '-',
        sporeBlowStatus: '-',
        sporeZBDMotorStatus: '-',
        sporeAPortStatus: '-',
        sporeStartTime: '',
        sporeSamplingTime: '',
        sporeRunHour: '',
        sporeWorkInterval: '',
        sporeSinglePulse: 0,
        sporePulseUpperLimit: 0,
        sporeTime: null,
      }
    },

    mounted() {
      this.sporeDeviceList();//获取孢子设备列表
    },

    beforeDestroy() {
      //关闭画面时 时间关闭清空
      clearInterval(this.sporeTime);
      this.sporeTime = null;
    },

    methods: {
      /**
       * 获取孢子设备列表
       */
      sporeDeviceList() {
        let that = this;
        this.$SporeSoilCommon.getSpDeviceList(function (deviceList) { //获取所有孢子虫情设备
          for(let i = 0; i < deviceList.data.length; i++) {
            if(deviceList.data[i].deviceType == 'spore') {//筛选孢子设备
              let sporeJson = {};
              sporeJson.deviceAddr = deviceList.data[i].deviceAddr;
              sporeJson.deviceName = deviceList.data[i].deviceName;
              that.sporeOption.push(sporeJson);
            }
          }
          if(that.sporeOption.length > 0) {
            that.sporeDevice = that.sporeOption[0].deviceAddr;//默认孢子设备id
            that.sporeRealDataTime();//获取设备实时数据
          }

        })
      },

      /**
       * 切换设备
       * @param event
       */
      sporeRealChange(event) {
        this.sporeDevice = event;
        clearInterval(this.sporeTime);
        this.sporeTime = null;
        this.sporeRealDataTime();//获取设备实时数据
      },

      /**
       * 获取设备实时数据
       */
      sporeRealDataTime() {
        let that = this;
        this.$SporeSoilCommon.spRealDataTime(this.sporeDevice, function (sporeList) {//获取实时数据
          that.setSporeRealData(sporeList);//画面设置填充数据
        });
        //每隔一分钟获取一次实时数据
        this.sporeTime = window.setInterval(() => {
          setTimeout(() => {
            this.$SporeSoilCommon.spRealDataTime(this.sporeDevice, function (sporeList) {
              that.setSporeRealData(sporeList);//画面设置填充数据
            })
          })
        }, 1000 * 60);

      },

      /**
       * 画面设置填充数据
       * @param sporeList
       */
      setSporeRealData(sporeList) {
        if(sporeList.data.length == 0) {
          this.sporeDeviceName = '-'; //设备名称
          this.sporeDeviceAddr = '-'; //设备地址
          this.sporeStatus = '-'; //设备状态
          this.sporeType = '-'; //设备类型
          this.sporePulseCurrent =  '-'; //单次脉冲数
          this.sporePulseTotal =  '-'; //累计脉冲数
          this.sporeAltitude = '-'; //海拔高度
          this.sporeSaveInterval = '-';//数据保存间隔
          this.sporeOffInterval = '-';//离线判断间隔
          this.sporeYMStatus = '-'; // Y轴电机状态
          this.sporeYMLimit = '-'; //Y轴电机脉冲范围
          this.sporeYMPulse = '-'; //Y轴电机脉冲数
          this.sporeYMDirection = '-'; //Y轴电机方向

          this.sporeRadio = ''; //设置模式

          this.sporeLightStatus =  '-'; //光源状态
          this.sporeSPortStatus = '-'; //采样口状态
          this.sporeBlowStatus = '-'; //排气口状态
          this.sporeZBDMotorStatus =  '-'; //载波带电机状态
          this.sporeAPortStatus = '-'; //吸气口状态

          this.sporeStartTime = ''; //开始时间
          this.sporeSamplingTime = ''; //采样时间
          this.sporeRunHour = ''; //工作时长
          this.sporeWorkInterval = ''; //工作间隔
          this.sporeSinglePulse = 0; //单次移动脉冲数
          this.sporePulseUpperLimit = 0; //累计脉冲上限

          return;
        }
        //上下共同属性状态
        this.sporeDeviceName = sporeList.data[0].deviceName;//设备名称
        this.sporeDeviceAddr = sporeList.data[0].deviceAddr;//设备地址
        this.sporeStatus = sporeList.data[0].status == 'online' ? '在线' : '离线'; //设备状态
        this.sporeType = '孢子'; //设备类型
        this.sporePulseCurrent =  sporeList.data[0].data.PulseCurrent; //单次脉冲数
        this.sporePulseTotal =  sporeList.data[0].data.PulseTotal; //累计脉冲数
        this.sporeAltitude = sporeList.data[0].data.Altitude; //海拔高度
        this.sporeYMStatus = sporeList.data[0].data.YMotorStatus == '0' ? '停止' : '运行'; // Y轴电机状态
        this.sporeYMLimit = sporeList.data[0].data.motorPulse; //Y轴电机脉冲范围
        this.sporeYMPulse = sporeList.data[0].data.YMotorPulse; //Y轴电机脉冲数
        this.sporeYMDirection = sporeList.data[0].data.YMotorDirection == '0' ? '前进' : '后退'; //Y轴电机方向
        this.getSporeDevice();//获取数据保存间隔和离线判断间隔

        //模式获取
        this.sporeRadio = sporeList.data[0].data.controlMode;

        //手动模式
        this.sporeLightStatus =  sporeList.data[0].data.IamphouseStatus == '0' ? '关闭' : '开启'; //光源状态
        this.sporeSPortStatus = sporeList.data[0].data.SamplingPortStatus == '0' ? '关闭' : '打开'; //采样口状态
        this.sporeBlowStatus = sporeList.data[0].data.BlowVentStatus == '0' ? '关闭' : '打开'; //排气口状态
        this.sporeZBDMotorStatus =  sporeList.data[0].data.ZBDMotorStatus == '0' ? '停止' : '运行'; //载波带电机状态
        this.sporeAPortStatus = sporeList.data[0].data.AdmissionPortStatus == '0' ? '关闭' : '打开'; //吸气口状态

        //自动模式
        this.getSporeAutoModel();
      },

      /**
       * 获取数据保存间隔和离线判断间隔
       */
      getSporeDevice() {
        sporeDeviceInfo(this.sporeDevice).then(response => {
          this.sporeSaveInterval = response.data.data[0].saveDateInterval; //数据保存间隔
          this.sporeOffInterval = response.data.data[0].offlineInterval; //离线判断间隔
        }).catch(error => {
          console.log("error", error)
        })
      },

      /**
       * 获取自动模式数据
       */
      getSporeAutoModel() {
        sporeAutoMode(this.sporeDevice).then(response => {
          this.sporeStartTime = response.data.data.beginTime; //开始时间
          this.sporeSamplingTime = response.data.data.samplingTime; //采样时间
          this.sporeRunHour = response.data.data.runHour; //工作时长
          this.sporeWorkInterval = response.data.data.workInterval; //工作间隔
          this.sporeSinglePulse = response.data.data.singlePulse; //单次移动脉冲数
          this.sporePulseUpperLimit = response.data.data.pulseUpperLimit; //累计脉冲上限
        }).catch(error => {
          console.log("error", error);
        })
      },

      /**
       * 切换运行模式
       * @param e
       */
      sporeModel(e) {
        // this.sporeRadio = e;
        // let param = {"deviceAddr": this.sporeDevice, "mode": this.sporeRadio};
        // console.log("nnnnnnnnnn",param)
        // deviceModel(param).then(response => {
        //       this.$message({
        //         showClose: true,
        //         type: 'success',
        //         message: '修改成功'
        //       })
        // }).catch(error => {
        //   console.log("error", error);
        // })

        this.$confirm('请确定是否切换运行模式？', '提示', {
          confirmButtonText: '确定',
          cancelButtonClass: '取消',
          type: 'warning'
        }).then(() => {
          this.sporeRadio = e;
          let sporeRadioName = this.sporeRadio == '0' ? '手动' : '自动';
          let param = {"deviceAddr": this.sporeDevice, "mode": this.sporeRadio};
          console.log("运行模式更改：", param);
          deviceModel(param).then(response => {
            this.$message({
              showClose: true,
              type: 'success',
              message: sporeRadioName + '运行模式切换成功'
            })
          }).catch(error => {
            this.sporeRadio = e == '1' ? '0' : '1';
            this.$message({
              showClose: true,
              type: 'warning',
              message: '运行模式切换失败'
            })
          })
        }).catch(() => {
          this.sporeRadio = e == '1' ? '0' : '1';
          this.$message({
            showClose: true,
            type: 'warning',
            message: '运行模式切换已取消'
          })
        })
      },

      /**
       * 更改光源状态
       */
      setLampHState() {
        // let opt = this.sporeLightStatus == '关闭' ? '1' : '0';
        // let param = {"deviceAddr": this.sporeDevice, "module": "IamphouseStatus", "opt": opt};
        // console.log("nnnnnnn", param)
        // deviceOper(param).then(response => {
        //   console.log("aaaaaaaaa");
        // }).catch(error => {
        //   console.log("error", error);
        // })
        this.$confirm('请确定是否更改光源状态', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let opt = this.sporeLightStatus == '关闭' ? '1' : '0';
          let param = {"deviceAddr": this.sporeDevice, "module": "IamphouseStatus", "opt": opt};
          console.log("更改光源状态", param);
          deviceOper(param).then(response => {
            this.sporeLightStatus = this.sporeLightStatus == '关闭' ? '开启' : '关闭';
            this.$message({
              showClose: true,
              type: 'success',
              message:'光源' + this.sporeLightStatus + '状态修改成功'
            })
          }).catch(error => {
            this.$message({
              showClose: true,
              type: 'warning',
              message: '更改光源状态失败'
            })
          })
        }).catch(() => {
          this.$message({
            showClose: true,
            type: 'warning',
            message: '更改光源状态已取消'
          })
        })
      },

      /**
       * 更改采样口状态
       */
      setSPortStatus() {
        this.$confirm('请确定是否改变采样口状态', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let opt = this.sporeSPortStatus == '关闭' ? '1' : '0';
          let param = {"deviceAddr": this.sporeDevice, "module": "SamplingPortStatus", "opt": opt};
          console.log("更改采样口状态", param);
          deviceOper(param).then(response => {
            this.sporeSPortStatus = this.sporeSPortStatus == '关闭' ? '打开' : '关闭';
            this.$message({
              showClose: true,
              type:'success',
              message: '采样口' + this.sporeSPortStatus + '状态修改成功'
            })
          }).catch(error => {
            this.$message({
              showClose: true,
              type: 'warning',
              message: '更改采样口状态失败'
            })
          })
        }).catch(() => {
          this.$message({
            showClose: true,
            type: 'warning',
            message: '更改采样口状态已取消'
          })
        })
      },

      /**
       * 更改排气口状态
       */
      setBlowVStatus() {
        this.$confirm('请确定是否更改排气口状态', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let opt = this.sporeBlowStatus == '关闭' ? '1' : '0';
          let param = {"deviceAddr": this.sporeDevice, "module": "BlowVentStatus", "opt": opt};
          console.log("更改排气口状态", param);
          deviceOper(param).then(response => {
            this.sporeBlowStatus = this.sporeBlowStatus == '关闭' ? '打开' : '关闭';
            this.$message({
              showClose: true,
              type: 'success',
              message: '排气口' + this.sporeBlowStatus + '状态修改成功'
            })
          }).catch(error => {
            this.$message({
              showClose: true,
              type: 'warning',
              message: '更改排气口状态失败'
            })
          })
        }).catch(error => {
          this.$message({
            showClose: true,
            type: 'warning',
            message: '更改采样口状态已取消'
          })
        })
      },

      /**
       * 更改载波带电机状态
       */
      setZBDMotorStatus() {
        this.$confirm('请确定是否更改载玻带电机状态', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let opt = this.sporeZBDMotorStatus == '停止' ? '1' : '0';
          let param = {"deviceAddr": this.sporeDevice, "module": "ZBDMotorStatus", "opt": opt};
          console.log("更改载波带电机状态", param);
          deviceOper(param).then(response => {
            this.sporeZBDMotorStatus = this.sporeZBDMotorStatus == '停止' ? '运行' : '停止';
            this.$message({
              showClose: true,
              type: 'success',
              message: '载波带电机' + this.sporeZBDMotorStatus + '状态修改成功'
            })
          }).catch(error => {
            this.$message({
              showClose: true,
              type: 'warning',
              message: '更改载波带电机状态失败'
            })
          })
        }).catch(() => {
          this.$message({
            showClose: true,
            type: 'warning',
            message: '更改载波带点击状态已取消'
          })
        })
      },

      /**
       * 更改吸气口状态
       */
      setAPortStatus() {
        this.$confirm('请确定是否更改吸气口状态', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let opt = this.sporeAPortStatus == '关闭' ? '1' : '0';
          let param = {"deviceAddr": this.sporeDevice, "module": "AdmissionPortStatus", "opt": opt};
          console.log("更改吸气口状态", param);
          deviceOper(param).then(response => {
            this.sporeAPortStatus = this.sporeAPortStatus == '关闭' ? '打开' : '关闭';
            this.$message({
              showClose: true,
              type: 'success',
              message: '吸气口' +  this.sporeAPortStatus + '状态修改成功'
            })
          }).catch(error => {
            this.$message({
              showClose: true,
              type: 'warning',
              message: '更改吸气口状态失败'
            })
          })
        }).catch(() => {
          this.$message({
            showClose: true,
            type: 'warning',
            message: '更改吸气口状态已取消'
          })
        })
      },

      /**
       * 拍摄
       */
      setPhotoGraph() {
        this.$confirm('请确认是否立即进行拍照', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let param = {"deviceAddr": this.sporeDevice, "module": "photograph", "opt": "1"};
          console.log("拍摄", param);
          deviceOper(param).then(response => {
            this.$message({
              showClose: true,
              type: 'success',
              message: '拍摄成功'
            })
          }).catch(error => {
            this.$message({
              showClose: true,
              type: 'warning',
              message: '拍摄失败'
            })
          })
        }).catch(() => {
          this.$message({
            showClose: true,
            type: 'warning',
            message: '取消拍照'
          })
        })
      },

      /**
       * 修改自动模式下的属性
       */
      setAutoMode() {
        let param = {"deviceAddr": this.sporeDevice, "beginTime": this.sporeStartTime, "runHour": this.sporeRunHour, "samplingTime": this.sporeSamplingTime,
          "workInterval": this.sporeWorkInterval, "singlePulse": this.sporeSinglePulse, "pulseUpperLimit": this.sporePulseUpperLimit};
        modSporeAutoMode(param).then(response => {
          this.$message({
            showClose: true,
            type: 'success',
            message: '修改设备自动模式时间成功'
          })
        }).catch(error => {
          this.$message({
            showClose: true,
            type: 'warning',
            message: '修改设备自动模式时间失败，请检查格式是否正确'
          })
        })
      }
    }
  }
</script>

<style lang="less">
  @import "../less/SporeRealData";
</style>

<style>
  .sporeReal-data-content::-webkit-scrollbar {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/view/SporeRealData.vue